import dayjs from 'dayjs';
import type { StateCreator } from 'zustand';

import type { Usuario } from '@infor/core/models/usuario';

import { mapPermissoes, type PermissoesAppInforcfc } from 'permissions';

export type UserSlice = {
  user: Usuario | null | undefined;
  permissoes: PermissoesAppInforcfc | null | undefined;
  token: string | null;
  syncDate: Date | string | null;
  setUser: (user: Usuario | null | undefined) => void;
  setPermissoes: (userPermissoes: string[] | null | undefined) => void;
  setToken: (token: string | null) => void;
  setSyncDate: (syncDate: Date | null) => void;
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  user: null,
  permissoes: null,
  token: null,
  syncDate: null,
  setUser: (user) => set((state) => ({ ...state, user })),
  setToken: (token) => set((state) => ({ ...state, token })),
  setSyncDate: (syncDate) =>
    set((state) => {
      const dataAjustada = syncDate
        ? dayjs(syncDate).subtract(3, 'hour').toISOString()
        : dayjs(new Date()).subtract(3, 'hour').toISOString();

      return { ...state, syncDate: dataAjustada };
    }),
  setPermissoes: (userPermissoes) =>
    set((state) => {
      const result = mapPermissoes(userPermissoes);

      return { ...state, permissoes: result };
    }),
});
